<template>
  <div class="main-container">
    <DimensionModel></DimensionModel>
    <TableNormal></TableNormal>
    <TableDetail></TableDetail>
    <lineModel></lineModel>
    <rengeModel></rengeModel>
    <hobbyModel></hobbyModel>
    <classScore></classScore>
    <totalScore />
    <latitudeRadar />
    <characteristics />
  </div>
</template>

<script>
import DimensionModel from "@/components/dataView/echarts/dimension";
import TableNormal from "@/components/dataView/table/normal";
import TableDetail from "@/components/dataView/table/detail";
import lineModel from "@/components/dataView/echarts/line";
import rengeModel from "@/components/dataView/echarts/renge";
import hobbyModel from "@/components/dataView/echarts/hobby";
import classScore from "@/components/dataView/echarts/classScore";
import totalScore from "@/components/dataView/echarts/totalScore";

import latitudeRadar from "@/components/dataView/echarts/latitudeRadar";
import characteristics from "@/components/dataView/table/three/characteristics";
export default {
  components: {
    DimensionModel,
    TableNormal,
    TableDetail,
    lineModel,
    rengeModel,
    hobbyModel,
    classScore,
    totalScore,
    latitudeRadar,
    characteristics,
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  padding: 20px;
  width: 800px;
  height: auto;
  margin: 0px auto;
  background-color: white;
  * {
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/models.vue